const facebookSegmentRules = [
  {
    name: 'Viewed product',
    key: 'viewedProduct',
    event: 'ViewContent',
    inverseSelection: false,
    availableFilters: {
      count: {},
      retentionDays: {},
      value: {},
    },
  },
  {
    name: 'Added to cart',
    key: 'addedToCart',
    event: 'AddToCart',
    inverseSelection: false,
    availableFilters: {
      count: {},
      retentionDays: {},
      value: {},
    },
  },
  {
    name: 'Added to whislist',
    key: 'addedToWishlist',
    event: 'AddToWishlist',
    availableFilters: {
      count: {},
      retentionDays: {},
      value: {},
    },
  },
  {
    name: 'Purchased',
    key: 'purchased',
    event: 'Purchase',
    inverseSelection: false,
    availableFilters: {
      count: {},
      retentionDays: {},
      value: {},
    },
  },
  {
    name: 'Subscribed',
    key: 'profileSubscribed',
    inverseSelection: false,
    event: 'CompleteRegistration',
    availableFilters: {
      retentionDays: {},
    },
  },
  {
    name: 'Custom Event',
    key: 'customEvent',
    inverseSelection: false,
    availableFilters: {
      event: {},
      count: {},
      retentionDays: {},
      value: {},
    },
  },
];

export const facebookAudienceOptions = {
  externalScope: [
    { label: 'Audience Rules', value: 'audienceRules' },
    { label: 'Segment Lookalikes', value: 'audienceLookalikes' },
    { label: 'Page Fans Lookalikes', value: 'pageLikeLookalikes' },
  ],
  lookalikeType: [
    { label: 'Reach', value: 'reach' },
    { label: 'Similarity', value: 'similarity' },
  ],
};

export default facebookSegmentRules;
